import React from 'react';
import { ScreenSizeDetector } from '../../../../../lib/helpers';
import { Col } from '../../../../grid';
import { Bold, Paragraph } from '../../../../typography';
import { AlcoholPercentage } from '../../../parts';

const RenderAlcPctBottles = ({
  alcoholPercentage,
  productTypeGlass,
  productTypeReservedel,
  alcPctNum,
  showAlcPct,
  productTypeFadoel,
  productTypePack,
}) => {
  if (productTypeGlass || productTypeReservedel || (!showAlcPct && alcPctNum <= 0) || productTypeFadoel || productTypePack) {
    return null;
  }
  return (
    <ScreenSizeDetector padding={[[1599, '5px 15px'], '15px']}>
      <Col xs={6} sm={3} md={3} lg={6} xl={6} xxl={3}>
        <Paragraph marginBottom="0">
          <Bold>Alkohol:</Bold><br />
          <AlcoholPercentage value={alcoholPercentage} />
        </Paragraph>
      </Col>
    </ScreenSizeDetector>
  );
};

export default RenderAlcPctBottles;
